import ambalangoda_1 from "src/assets/images/lifestyle/ambalangoda/ambalangoda_1.webp";
import ambalangoda_2 from "src/assets/images/lifestyle/ambalangoda/ambalangoda_2.webp";
import ambalangoda_3 from "src/assets/images/lifestyle/ambalangoda/ambalangoda_3.webp";
import ambalangoda_4 from "src/assets/images/lifestyle/ambalangoda/ambalangoda_4.webp";
import ambalangoda_5 from "src/assets/images/lifestyle/ambalangoda/ambalangoda_5.webp";
import ambalangoda_6 from "src/assets/images/lifestyle/ambalangoda/ambalangoda_6.webp";

import convocation_1 from "src/assets/images/lifestyle/convocation/convocation_1.webp";
import convocation_2 from "src/assets/images/lifestyle/convocation/convocation_2.webp";
import convocation_3 from "src/assets/images/lifestyle/convocation/convocation_3.webp";

import hanthana_1 from "src/assets/images/lifestyle/hanthana/hanthana_1.webp";
import hanthana_2 from "src/assets/images/lifestyle/hanthana/hanthana_2.webp";
import hanthana_3 from "src/assets/images/lifestyle/hanthana/hanthana_3.webp";

import knuckles_1 from "src/assets/images/lifestyle/knuckles/knuckles_1.webp";
import knuckles_2 from "src/assets/images/lifestyle/knuckles/knuckles_2.webp";
import knuckles_3 from "src/assets/images/lifestyle/knuckles/knuckles_3.webp";
import knuckles_4 from "src/assets/images/lifestyle/knuckles/knuckles_4.webp";
import knuckles_5 from "src/assets/images/lifestyle/knuckles/knuckles_5.webp";
import knuckles_6 from "src/assets/images/lifestyle/knuckles/knuckles_6.webp";
import knuckles_7 from "src/assets/images/lifestyle/knuckles/knuckles_7.webp";

import laxapana_1 from "src/assets/images/lifestyle/laxapana/laxapana_1.webp";
import laxapana_2 from "src/assets/images/lifestyle/laxapana/laxapana_2.webp";
import laxapana_3 from "src/assets/images/lifestyle/laxapana/laxapana_3.webp";

export const LIFESTYLE = [
    {
      id: 1,
      images: [ambalangoda_1, ambalangoda_2, ambalangoda_3, ambalangoda_4, ambalangoda_5, ambalangoda_6],
      title: "Ambalangoda Beach",
      description: "Relaxing by the golden sands and crystal-clear waters."
    },
    {
      id: 2,
      images: [laxapana_1, laxapana_2, laxapana_3],
      title: "Laxapana Falls",
      description: "Witnessed the breathtaking waterfall in the heart of nature."
    },
    {
      id: 3,
      images: [knuckles_1, knuckles_2, knuckles_3, knuckles_4, knuckles_5, knuckles_6, knuckles_7],
      title: "Knuckles Mountain Range",
      description: "Hiked through misty peaks and lush green trails."
    },
    {
      id: 4,
      images: [convocation_1, convocation_2, convocation_3],
      title: "Convocation",
      description: "A proud milestone celebrating years of hard work."
    },
    {
      id: 5,
      images: [hanthana_1, hanthana_2, hanthana_3],
      title: "Hanthana Mountain Range",
      description: "Enjoyed an adventurous trek with stunning panoramic views."
    }
];